import Swiper, { Navigation, HashNavigation, Thumbs, Pagination, Autoplay, Controller } from 'swiper';
import { debounce } from 'throttle-debounce';

function init() {
  Swiper.use([Navigation, HashNavigation, Thumbs, Pagination, Autoplay, Controller]);

  var acfeLayoutSlug = 'section_navigation';
  var $layouts = $('.layout');
  var $layout = $('.layout-section-navigation:first'); // TODO: (maybe). no accommodation for multiple section nav layouts per page
  var swiperNavSelector = '.swiper-nav';
  var swiperSelector = '.swiper';
  var swiperNavOptions = {
    slidesPerView: 'auto',
    loop: false,
    watchSlidesProgress: true, // required for thumbs
    freeMode: false, // set to true to allow non-sticky slide positions
    // spaceBetween: 50, // spaceBetween isn't swipable. using css padding on content within .swiper-slide instead.
    threshold: 50, // px
  };

  var $swiperDirections = $layout.find('.swiper-nav-directions');
  var $swiper = $layout.find(swiperNavSelector);
  var swiperNav = new Swiper($swiper.get(0), swiperNavOptions);

  var toggleSwiperDirections = function() {
    var slidesWidth = 0;
    var swiperWidth = $swiper.width();
    var swiperWidthAdjusted = swiperWidth + 22.5; // 22.5px (for the .p-4 on content within .swiper-slide)

    $swiper.find('.swiper-slide').each(function() {
      slidesWidth += $(this).width();
    });

    if(slidesWidth > swiperWidthAdjusted) {
      $swiperDirections.show();
    }
    else {
      $swiperDirections.hide();
    }
  }
  $(window).on('resize', debounce(100, toggleSwiperDirections));
  toggleSwiperDirections();

  var scrollToTarget = function(selector, offset) {
    selector = (typeof selector !== 'undefined') ? selector : false;
    offset = (typeof offset !== 'undefined') ? offset : 0;
    if($('body').hasClass('admin-bar')) {
      offset += 32;
    }
    if(selector) {
      var $target = $(selector);
      if($target.length) {
        var top = $target.offset().top;
        var targetTop = top - offset;
        var currentTop = $(document).scrollTop();
        var animationSpeedBase = 500; // milliseconds
        var scrollDistance = targetTop - currentTop;
        var scrollSpeedFactor = scrollDistance / 1000;
        var animationSpeedAdjusted = Math.max(animationSpeedBase, Math.round(scrollSpeedFactor * animationSpeedBase));
        // console.log('currentTop' + currentTop);
        // console.log('targetTop' + targetTop);
        // console.log('scrollDistance' + scrollDistance);
        // console.log('scrollSpeedFactor' + scrollSpeedFactor);
        // console.log('animationSpeedAdjusted' + animationSpeedAdjusted);
        $('html, body').animate({ scrollTop: targetTop }, animationSpeedAdjusted);
        return;
      }
    }
  }

  var $links = $layout.find('a');
  $links.on('click', function(e) {
    e.preventDefault();
    $layouts.removeClass('fade-in-up');
    var slug = $(this).attr('href').replace('#', '');
    var selector = '.layout[data-hash="' + slug + '"]';
    scrollToTarget(selector);
  });

  // https://www.elated.com/jquery-removing-replacing-moving-elements/
  $layout.detach().appendTo('#section-navigation-js-target').unwrap();

  // admin previews disabled
  // window.acf && window.acf.addAction('acfe/fields/flexible_content/preview/name=layouts&layout=' + acfeLayoutSlug, function(response, $flexible, $layout, ajaxData) {
  //   initSwiperForLayout($layout);
  // });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/sectionNavigation.js